<template>
  <div class="login">
    <b-row align-h="center" align-v="center" class="m-0" style="height: 100vh">
      <div class="body">
        <b-row align-h="center" align-v="center" class="m-0 h-100">
          <div class="main">
            <img src="../assets/kimaker_logo.png" class="logo" />
            <div class="title">扣件智慧生產系統</div>
            <div class="form-title">請輸入帳號密碼</div>
            <form>
              <div>
                <input
                  type="text"
                  name="uid"
                  id="account"
                  v-model="user.uID"
                  autocomplete="off"
                  placeholder="登入帳號"
                />
              </div>
              <div>
                <input
                  type="password"
                  name="pwd"
                  id="password"
                  v-model="user.pwd"
                  autocomplete="off"
                  placeholder="登入密碼"
                />
              </div>
              <div>
                <input
                  name="button"
                  type="submit"
                  id="login"
                  value="登入"
                  @click.prevent="checkUser"
                />
              </div>
            </form>
            <div class="footer"></div>
          </div>
        </b-row>
      </div>
    </b-row>
    <!-- <div class="body">
      <div class="main">
        <img src="../assets/kimaker_logo.png" class="logo" />
        <div class="title">扣件智慧生產系統</div>
        <div class="form-title">請輸入帳號密碼</div>
        <form>
          <div>
            <input
              type="text"
              name="uid"
              id="account"
              v-model="user.uID"
              autocomplete="off"
              placeholder="登入帳號"
            />
          </div>
          <div>
            <input
              type="password"
              name="pwd"
              id="password"
              v-model="user.pwd"
              autocomplete="off"
              placeholder="登入密碼"
            />
          </div>
          <div>
            <input
              name="button"
              type="submit"
              id="login"
              value="登入"
              @click.prevent="checkUser"
            />
          </div>
        </form>
        <div class="footer"></div>
      </div>
    </div> -->
    <alertModal />
  </div>
</template>

<script>
import modal from "@/components/modal.vue";
import alertModal from "@/components/alertModal.vue";
import { mapGetters, mapActions } from "vuex";
import { childRouter } from "@/router/childRouter";
export default {
  name: "login",
  data() {
    return {
      user: {
        uID: "",
        pwd: ""
        // uID: "admin",
        // pwd: "sapidotest@2019"
      }
    };
  },
  components: {
    modal,
    alertModal
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      pageAccess: "getlogin/get_pageAccess",
      pageName: "getlogin/get_pageName",
      accessList: "accessList/get_accessList"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      change_loginData: "getlogin/change_loginData",
      change_pageAccess: "getlogin/change_pageAccess",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName"
    }),
    checkUser(e) {
      let vm = this;
      var params = {};
      params["methods"] = "GET";
      params["whichFunction"] = "Login";
      params["uID"] = vm.user.uID;
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] != "ok") {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        } else {
          if (result["QueryTableData"].length > 0) {
            if (vm.user.pwd === result["QueryTableData"][0].pwd) {
              vm.set_alertMsg("登入成功");
              vm.settimeout_alertModal();
              var obj = {};
              obj.account = vm.user.uID;
              obj.status = true;
              obj.username = result["QueryTableData"][0].name;
              obj.accessList = result["QueryTableData"][0].access_type;
              vm.change_loginData(obj);
              var pageAccessObj = Object.assign({}, vm.pageAccess);
              if (vm.accessList[obj.accessList] == undefined) {
                vm.set_alertMsg("登入失敗");
                vm.settimeout_alertModal();
              } else {
                vm.accessList[obj.accessList].forEach(data => {
                  pageAccessObj[data] = true;
                });
                vm.change_pageAccess(pageAccessObj);
                vm.change_selectPage("home");
                vm.change_selectPageName(vm.pageName.home);
                vm.$router.addRoutes(childRouter);
                vm.$router.push("/index");
              }
            } else {
              vm.set_alertMsg("帳號或密碼錯誤");
              vm.settimeout_alertModal();
            }
          } else {
            vm.set_alertMsg("帳號或密碼錯誤");
            vm.settimeout_alertModal();
          }
        }
      });
      //===========================測試SSO用===========================//
      // var expires = new Date();
      // //有效時間保存 6 小時 6*60*60*1000
      // expires.setTime(expires.getTime() + 21600000);
      // document.cookie =
      //   "sso=" + escape("test00001") + ";expires=" + expires.toGMTString();

      //===========================測試用===========================//

      // if (
      //   (vm.user.uID == "iot" && vm.user.pwd == "sapido@0818") ||
      //   (vm.user.uID == "admin_nfu" && vm.user.pwd == "20210818") ||
      //   (vm.user.uID == "m001" && vm.user.pwd == "ofco@0818") ||
      //   (vm.user.uID == "ofco_mfg" && vm.user.pwd == "mfg@0818") ||
      //   (vm.user.uID == "chunbang" && vm.user.pwd == "cb@0818")
      // ) {
      //   var obj = {};
      //   obj.account = vm.user.uID;
      //   obj.status = true;
      //   obj.username = vm.user.uID;
      //   obj.accessList = "general";
      //   vm.change_loginData(obj);
      //   var pageAccessObj = Object.assign({}, vm.pageAccess);
      //   if (vm.accessList[obj.accessList] == undefined) {
      //     vm.set_alertMsg("登入失敗");
      //     vm.settimeout_alertModal();
      //   } else {
      //     vm.accessList[obj.accessList].forEach(data => {
      //       pageAccessObj[data] = true;
      //     });
      //     vm.change_pageAccess(pageAccessObj);
      //     vm.change_selectPage("home");
      //     vm.change_selectPageName(vm.pageName.home);
      //     vm.$router.addRoutes(childRouter);
      //     vm.$router.push("/index");
      //   }
      // } else if (vm.user.uID == "admin" && vm.user.pwd == "sapido@0818") {
      //   var obj = {};
      //   obj.account = vm.user.uID;
      //   obj.status = true;
      //   obj.username = vm.user.uID;
      //   obj.accessList = "admin";
      //   console.log(obj);
      //   console.log(vm.accessList);
      //   console.log(vm.accessList[obj.accessList]);
      //   vm.change_loginData(obj);
      //   var pageAccessObj = Object.assign({}, vm.pageAccess);
      //   if (vm.accessList[obj.accessList] == undefined) {
      //     vm.set_alertMsg("登入失敗");
      //     vm.settimeout_alertModal();
      //   } else {
      //     vm.accessList[obj.accessList].forEach(data => {
      //       pageAccessObj[data] = true;
      //     });
      //     vm.change_pageAccess(pageAccessObj);
      //     vm.change_selectPage("home");
      //     vm.change_selectPageName(vm.pageName.home);
      //     vm.$router.addRoutes(childRouter);
      //     vm.$router.push("/index");
      //   }
      // } else if (vm.user.uID == "ofco_pc" && vm.user.pwd == "pc@0818") {
      //   var obj = {};
      //   obj.account = vm.user.uID;
      //   obj.status = true;
      //   obj.username = vm.user.uID;
      //   obj.accessList = "PC";
      //   vm.change_loginData(obj);
      //   var pageAccessObj = Object.assign({}, vm.pageAccess);
      //   if (vm.accessList[obj.accessList] == undefined) {
      //     vm.set_alertMsg("登入失敗");
      //     vm.settimeout_alertModal();
      //   } else {
      //     vm.accessList[obj.accessList].forEach(data => {
      //       pageAccessObj[data] = true;
      //     });
      //     vm.change_pageAccess(pageAccessObj);
      //     vm.change_selectPage("home");
      //     vm.change_selectPageName(vm.pageName.home);
      //     vm.$router.addRoutes(childRouter);
      //     vm.$router.push("/index");
      //   }
      // } else {
      //   vm.set_alertMsg("帳號或密碼錯誤");
      //   vm.settimeout_alertModal();
      //   return;
      // }

      //===========================測試用===========================//
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*頁面框架*/
.login .body {
  background: white;
  opacity: 1;
  width: 31.5rem;
  height: 31.5rem;

  /*外框圓弧黑框*/
  border: solid 3pt #646569;
  border-radius: 50px;

  /*定位對齊*/
  /* position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -15.75rem;
  margin-left: -15.75rem; */
}

.login .body .main .logo {
  width: 18rem;
  height: auto;
  display: block;
  margin: 0 auto auto;
}
.login .body .main .title {
  margin: auto;
  margin-top: 1.9rem;
  text-align: center;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  font-size: 2rem;
  height: 2rem;
  line-height: 2rem;
  color: #646569;
}
.login .body .main .form-title {
  margin: auto;
  margin-top: 5rem;
  text-align: center;
  font-family: "微軟正黑體";
  font-weight: bold;
  font-size: 1rem;
  height: 1rem;
  line-height: 1rem;
  color: #646569;
}
.login .body .main form {
  margin: 0.75rem auto auto;
  width: 18rem;
}
.login .body .main form > div {
  margin: 0.3rem auto auto;
  width: 100%;
  height: 1.9rem;
}
.login .body .main form > div input {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  border: solid 1pt #646569;
  font-size: 1rem;
  font-family: "微軟正黑體";
  padding: 0px;
}
.login .body .main form > div #account,
.login .body .main form > div #password {
  color: #000000;
  text-indent: 0.95rem;
}
.login .body .main form > div #login {
  color: #ffffff;
  background-color: #646569;
}
.login .body .main form > div #login:hover {
  border: solid 1pt #db6937;
  background-color: #db6937;
}

.login .body .main .footer {
  margin: 1.25rem auto auto;
  width: 12.5rem;
}
.login .body .main .footer:after {
  content: "©金智洋科技股份有限公司開發";
  display: block;
  width: 100%;
  height: 0.875rem;
  line-height: 0.875rem;
  font-size: 0.875rem;
  color: #000000;
  font-family: "微軟正黑體";
}

::placeholder {
  font-family: "微軟正黑體";
  font-weight: bold;
  color: #cccccc !important;
  font-size: 1.125rem;
}

@media screen and (max-width: 31.5rem) {
  /*頁面框架*/
  .login .body {
    width: 20rem;

    /*外框圓弧黑框*/
    border: solid 3pt #646569;
    border-radius: 50px;

    /*定位對齊*/
    /* margin-left: -10rem; */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue